import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/home');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/home" className="logo">
          <img src="https://a1.boltp.com/2026/05/04/69f87b21e7716.png" alt="Logo" className="logo-img" />
        </Link>
        <div className="nav-links">
          <Link to="/home" className="nav-link">首页</Link>
          <Link to="/line" className="nav-link">线路图</Link>
          <Link to="/map" className="nav-link">3D地图</Link>
          <Link to="/announcement" className="nav-link">公告</Link>
          <Link to="/diplomacy" className="nav-link">外交</Link>
          <Link to="/gallery" className="nav-link">画廊</Link>
          <Link to="/join" className="nav-link">加入</Link>
          <Link to="/download" className="nav-link">下载</Link>
          <Link to="/image" className="nav-link">图床</Link>
          <Link to="/apply" className="nav-link">申请</Link>
          <Link to="/account" className="nav-link">账号</Link>
          {user && (user.permission === '腐竹' || user.permission === '管理') && (
            <Link to="/admin" className="nav-link admin-link">管理</Link>
          )}
        </div>
        <div className="nav-user">
          {user && (
            <>
              <span className="user-info">{user.gameId}</span>
              <button onClick={handleLogout} className="logout-btn">退出</button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
